export const SCHEDULE_LAST_OCCURRENCE_STATUS = {
  RUNNING: {
    name: 'RUNNING',
    title: 'Running',
    icon: 'common.loading',
  },
  SUCCESSFUL: {
    name: 'SUCCESSFUL',
    title: 'Success',
    icon: 'common.success',
  },
  FAILED: {
    name: 'FAILED',
    title: 'Failed',
    icon: 'common.failed',
  },
  SKIPPED: {
    name: 'SKIPPED',
    title: 'Skipped',
    icon: 'common.skipped',
  },
  OVERLAPPED: {
    name: 'OVERLAPPED',
    title: 'Overlapped',
    icon: 'worktrigger.overlapped',
  },
  MISSED: {
    name: 'MISSED',
    title: 'Missed',
    icon: 'common.error',
  },
};

export const SCHEDULE_STATUSES = {
  ACTIVE: {
    name: 'ACTIVE',
    title: 'Active',
    icon: 'common.pending',
  },
  PAUSED: {
    name: 'PAUSED',
    title: 'Paused',
    icon: 'common.paused',
  },
  COMPLETED: {
    name: 'COMPLETED',
    title: 'Completed',
    icon: 'common.completed',
  },
};

export const SCHEDULE_TYPES = {
  unknown: {
    name: 'unknown',
    icon: 'common.unknown',
    title: 'Unknown',
  },
  one: {
    name: 'one',
    icon: 'worktrigger.once',
    title: 'Once',
  },
  poll: {
    name: 'poll',
    icon: 'worktrigger.repeat',
    title: 'Hourly',
  },
  day: {
    name: 'day',
    icon: 'worktrigger.repeat',
    title: 'Daily',
  },
  dow: {
    name: 'dow',
    icon: 'worktrigger.repeat',
    title: 'Weekly',
  },
  dom: {
    name: 'dom',
    icon: 'worktrigger.repeat',
    title: 'Monthly',
  },
  dowom: {
    name: 'dowom',
    icon: 'worktrigger.repeat',
    title: 'Monthly on day',
  },
  domoy: {
    name: 'domoy',
    icon: 'worktrigger.repeat',
    title: 'Annually',
  },
  dowomoy: {
    name: 'dowomoy',
    icon: 'worktrigger.repeat',
    title: 'Annually on day',
  },
  avail: {
    name: 'avail',
    icon: 'worktrigger.repeat',
    title: 'Repeat avail',
  },
};
